// import React from "react"

import LocaleWrap from "./wrapPageElement"
import "./src/styles/global.css"

export const wrapPageElement = LocaleWrap
